import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["invoiceAddress", "sameAddressCheckbox"];

  connect() {
    this.initializeAddressSelections();

    if (this.hasSameAddressCheckboxTarget) {
      this.sameAddressCheckboxTarget.addEventListener('change', this.toggleInvoiceAddress.bind(this));
    }

    document.querySelectorAll('input[name="contracting_address_id"]').forEach(address => {
      address.addEventListener('click', this.syncAddresses.bind(this));
    });

    document.querySelectorAll('input[name="contracting_address"]').forEach(address => {
      address.addEventListener('click', this.syncAddressesAlternative.bind(this));
    });
  }

  toggleInvoiceAddress() {
    if (this.hasInvoiceAddressTarget) {
      this.invoiceAddressTarget.classList.toggle("d-none");
    }
    this.syncAddresses();
    if (this.hasSameAddressCheckboxTarget && this.sameAddressCheckboxTarget.checked === false) {
      document.querySelectorAll('input[name="invoice_address_id"]').forEach(el => el.checked = false);
    }
  }

  syncAddresses() {
    if (this.hasSameAddressCheckboxTarget && this.sameAddressCheckboxTarget.checked) {
      let checkedContractingAddresses = document.querySelectorAll('input[name="contracting_address_id"]:checked');

      document.querySelectorAll('input[name="invoice_address_id"]').forEach(el => el.checked = false);

      checkedContractingAddresses.forEach(contractingAddress => {
        let idValue = contractingAddress.dataset.id;
        let invoiceAddressToFind = document.querySelector(`input[name="invoice_address_id"]#address-item-${idValue}-invoice`);

        if (invoiceAddressToFind) {
          invoiceAddressToFind.checked = true;
        }
      });
    }
  }

  initializeAddressSelections() {
    var contracting_labels = document.querySelectorAll('.contracting_address label');
    var invoice_labels = document.querySelectorAll('.invoice_address label');
    var contracting_address = document.querySelector('.contracting_address .default_contracting_address');
    var invoice_address = document.querySelector('.invoice_address .default_invoicing_address');

    if (contracting_labels?.length === 1) document.querySelector('.contracting_address label').click();

    if (invoice_labels?.length === 1) document.querySelector('.invoice_address label').click();

    if (contracting_address?.className?.includes('default_contracting_address')) {
      contracting_address.closest('.contracting_item')?.querySelector('label')?.click();
    }

    if (invoice_address?.className?.includes('default_invoicing_address')) {
      invoice_address.closest('.invoice_item')?.querySelector('label')?.click();
    }
  }

  syncAddressesAlternative(event) {
    if (this.hasSameAddressCheckboxTarget && this.sameAddressCheckboxTarget.checked) {
      let checkedContractingAddress = event.target;

      if (checkedContractingAddress.checked) {
        let idValue = checkedContractingAddress.dataset.id;
        let invoiceAddressToFind = document.querySelector(`input[name="invoice_address"]#address-item-${idValue}-invoice`);

        if (invoiceAddressToFind) {
          invoiceAddressToFind.checked = true;
        }
      }
    }
  }

  validateAddresses() {
    setTimeout(() => {
      let error = document.querySelector('ul.parsley-errors-list.filled');

      document.querySelectorAll('.contracting_address .add_new_address').forEach(el => el.classList.remove('mt-3'));
      document.querySelectorAll('.invoice_address .add_new_address').forEach(el => el.classList.remove('mt-3'));

      if (document.querySelectorAll('.contracting_address .parsley-errors-list.filled').length > 0) {
        document.querySelector('.contracting_address .add_new_address').classList.add('mt-3');
      }
      if (document.querySelectorAll('.invoice_address .parsley-errors-list.filled').length > 0) {
        document.querySelector('.invoice_address .add_new_address').classList.add('mt-3');
      }
      if (error) {
        error.closest('div').parentElement.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  }
}
